import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as store_token from '@/services/store_token.js'
import ui from './modules/ui.js'
import map_params from './modules/map_params.js'
import router from '../router/index.js'

Vue.use(Vuex)
const server_path = process.env.VUE_APP_HTTP_S + '://' + process.env.VUE_APP_API_HOST + ':' + process.env.VUE_APP_API_PORT + '/api/';
export default new Vuex.Store({
  modules: {
    ui,
    map_params
  },
  state: {
    status: '',
    auth_token: store_token.getlocalToken('auth_token') || '',
    refresh_token:store_token.getlocalToken('refresh_token') || '',
    user : store_token.getlocalToken('user') || '',
    isLoading: false,
    legendURL: '',
    // Map layers
    mapLayers: {
      layerMosaics: {
        layerMosaicsVisible: true,
        mosaicsGlobal: true,
        mosaicsCampaigns: false,
        mosaicsCampaignsList: [],
        mosaicsCampaignsListFiltered: [],
        mosaicCampaignSelected: null,
        mosaicUid: ''
      },
      layerSonars: {
        layerSonarsVisible: false,
        sonarsGlobal: true,
        sonarsCampaigns: false,
        sonarsCampaignsList: [],
        sonarsCampaignsListFiltered: [],
        sonarCampaignSelected: null,
        sonarUid: ''
      },
      layerParams: {
        layerParamsVisible: false,
        paramsStations: true,
        paramsDensityMaps: false,
        paramsCampaignsList: [],
        paramsCampaignsListFiltered: [],
        paramsCampaignSelected: null,
        platform_id: '',
        densitySelectedParam: 'Clorofila_surface'
      },
      layerBathymetry: {
        layerBathymetryVisible: false,
        bathymetryGlobal: true,
        bathymetryCampaigns: false,
        bathymetryCampaignsList: [],
        bathymetryCampaignsListFiltered: [],
        bathymetryCampaignSelected: null,
        bathymetryUid: ''
      },
    },
    UI: {
      theme : 'normal',
    },
  },
  mutations: {
      // AUTH
      auth_request(state){
        state.status = 'loading'
      },
      auth_success(state, data){
        state.status = 'success'
        state.auth_token = data.auth_token
        state.refresh_token = data.refresh_token
        state.user = data.user
      },
      auth_error(state){
        state.status = 'error'
      },
      logout(state){
        state.status = ''
        state.auth_token = ''
        state.refresh_token = ''
      },
      auth_validate(state, auth_token){
        state.status = 'success'
        state.auth_token = auth_token
      },
      // Loader
      set_loader_status(state, data) {
        state.isLoading = data
      },
      set_legendURL_status(state, data) {
        state.legendURL = data
      },
      // Map layers mutations
      set_layer_visible(state, payload){
        switch(payload.layer){
          case "mosaics":
            state.mapLayers.layerMosaics.layerMosaicsVisible = true
            if (state.mapLayers.layerParams.layerParamsVisible) state.mapLayers.layerParams.layerParamsVisible = false
            if (state.mapLayers.layerBathymetry.layerBathymetryVisible) state.mapLayers.layerBathymetry.layerBathymetryVisible = false
            if (state.mapLayers.layerSonars.layerSonarsVisible) state.mapLayers.layerSonars.layerSonarsVisible = false
            break
          case "sonars":
            state.mapLayers.layerSonars.layerSonarsVisible = true
            if (state.mapLayers.layerParams.layerParamsVisible) state.mapLayers.layerParams.layerParamsVisible = false
            if (state.mapLayers.layerBathymetry.layerBathymetryVisible) state.mapLayers.layerBathymetry.layerBathymetryVisible = false
            if (state.mapLayers.layerMosaics.layerMosaicsVisible) state.mapLayers.layerMosaics.layerMosaicsVisible = false
            break
          case "params":
            state.mapLayers.layerParams.layerParamsVisible = true
            if (state.mapLayers.layerMosaics.layerMosaicsVisible) state.mapLayers.layerMosaics.layerMosaicsVisible = false
            if (state.mapLayers.layerBathymetry.layerBathymetryVisible) state.mapLayers.layerBathymetry.layerBathymetryVisible = false
            if (state.mapLayers.layerSonars.layerSonarsVisible) state.mapLayers.layerSonars.layerSonarsVisible = false
            break
          case "bathymetry":
            state.mapLayers.layerBathymetry.layerBathymetryVisible = true
            if (state.mapLayers.layerMosaics.layerMosaicsVisible) state.mapLayers.layerMosaics.layerMosaicsVisible = false
            if (state.mapLayers.layerParams.layerParamsVisible) state.mapLayers.layerParams.layerParamsVisible = false
            if (state.mapLayers.layerSonars.layerSonarsVisible) state.mapLayers.layerSonars.layerSonarsVisible = false
            break
        }
      },
      // Mosaics mutations
      set_mosaics_global_or_campaigns(state, payload){
        switch(payload.globalOrCampaigns){
          case "global":
            state.mapLayers.layerMosaics.mosaicsGlobal = !state.mapLayers.layerMosaics.mosaicsGlobal
            if(state.mapLayers.layerMosaics.mosaicsGlobal) state.mapLayers.layerMosaics.mosaicsCampaigns = false
            break
          case "campaigns":
            state.mapLayers.layerMosaics.mosaicsCampaigns = !state.mapLayers.layerMosaics.mosaicsCampaigns
            if(state.mapLayers.layerMosaics.mosaicsCampaigns) state.mapLayers.layerMosaics.mosaicsGlobal = false
            break
        }
      },
      set_mosaics_campaigns_list (state, payload){
        state.mapLayers.layerMosaics.mosaicsCampaignsList = payload.mosaicsCampaignsList
      },
      set_mosaics_campaigns_list_filtered (state, payload){
        state.mapLayers.layerMosaics.mosaicsCampaignsListFiltered = payload.mosaicsCampaignsListFiltered
      },
      set_mosaic_campaign_selected (state, payload){
        state.mapLayers.layerMosaics.mosaicCampaignSelected = payload
      },

      //Sonar mutations
      set_sonars_global_or_campaigns(state, payload){
        switch(payload.globalOrCampaigns){
          case "global":
            state.mapLayers.layerSonars.sonarsGlobal = !state.mapLayers.layerSonars.sonarsGlobal
            if(state.mapLayers.layerSonars.sonarsGlobal) state.mapLayers.layerSonars.sonarsCampaigns = false
            break
          case "campaigns":
            state.mapLayers.layerSonars.sonarsCampaigns = !state.mapLayers.layerSonars.sonarsCampaigns
            if(state.mapLayers.layerSonars.sonarsCampaigns) state.mapLayers.layerSonars.sonarsGlobal = false
            break
        }
      },
      set_sonars_campaigns_list (state, payload){
        state.mapLayers.layerSonars.sonarsCampaignsList = payload.sonarsCampaignsList
      },
      set_sonars_campaigns_list_filtered (state, payload){
        state.mapLayers.layerSonars.sonarsCampaignsListFiltered = payload.sonarsCampaignsListFiltered
      },
      set_sonar_campaign_selected (state, payload){
        state.mapLayers.layerSonars.sonarCampaignSelected = payload
      },

      // Params mutations
      set_params_stations_or_density_maps(state, payload){
        switch(payload.stationsOrDensity){
          case "stations":
            state.mapLayers.layerParams.paramsStations = !state.mapLayers.layerParams.paramsStations
            if(state.mapLayers.layerParams.paramsDensityMaps) state.mapLayers.layerParams.paramsDensityMaps = false
            break
          case "density":
            state.mapLayers.layerParams.paramsDensityMaps = !state.mapLayers.layerParams.paramsDensityMaps
            if(state.mapLayers.layerParams.paramsStations) state.mapLayers.layerParams.paramsStations = false
            break
        }
      },
      set_params_campaigns_list (state, payload){
        state.mapLayers.layerParams.paramsCampaignsList = payload.paramsCampaignsList
      },
      set_params_campaigns_list_filtered (state, payload){
        state.mapLayers.layerParams.paramsCampaignsListFiltered = payload.paramsCampaignsListFiltered
      },
      set_params_campaign_selected (state, payload){
        state.mapLayers.layerParams.paramsCampaignSelected = payload.paramsCampaignSelected
      },
      set_platform_id(state, id) {
        state.mapLayers.layerParams.platform_id = id
      },
      set_mosaic_uid(state, id) {
        state.mapLayers.layerMosaics.mosaicUid = id
      },
      set_bathymetry_uid(state, id) {
        state.mapLayers.layerBathymetry.bathymetryUid = id
      },
      set_sonar_uid(state, id) {
        state.mapLayers.layerSonars.sonarUid = id
      },
      set_density_selected_param (state, payload){
        state.mapLayers.layerParams.densitySelectedParam = payload.densitySelectedParam
      },

      // Bathymetry mutations
      set_bathymetry_global_or_campaigns(state, payload){
        switch(payload.globalOrCampaigns){
          case "global":
            state.mapLayers.layerBathymetry.bathymetryGlobal = !state.mapLayers.layerBathymetry.bathymetryGlobal
            if(state.mapLayers.layerBathymetry.bathymetryGlobal) state.mapLayers.layerBathymetry.bathymetryCampaigns = false
            break
          case "campaigns":
            state.mapLayers.layerBathymetry.bathymetryCampaigns = !state.mapLayers.layerBathymetry.bathymetryCampaigns
            if(state.mapLayers.layerBathymetry.bathymetryCampaigns) state.mapLayers.layerBathymetry.bathymetryGlobal = false
            break
        }
      },
      set_bathymetry_campaigns_list (state, payload){
        state.mapLayers.layerBathymetry.bathymetryCampaignsList = payload.bathymetryCampaignsList
      },
      set_bathymetry_campaigns_list_filtered (state, payload){
        state.mapLayers.layerBathymetry.bathymetryCampaignsListFiltered = payload.bathymetryCampaignsListFiltered
      },
      set_bathymetry_campaign_selected (state, payload){
        state.mapLayers.layerBathymetry.bathymetryCampaignSelected = payload
      },

      // Theme mutation
      set_theme(state, payload) {
        state.UI.theme = payload.newTheme
      },
  },
  actions: {
    login({commit}, user){
        return new Promise((resolve, reject) => {
          commit('auth_request')
          axios({url: server_path + 'auth-oomur/login/', data: user, method: 'POST' })
          .then(resp => {
            if(resp.data.access){
              const data = {
                auth_token : resp.data.access,
                refresh_token : resp.data.refresh,
                user : user.username
              }
              store_token.setlocalToken('auth_token',data.auth_token)
              store_token.setlocal('refresh_token',data.refresh_token)
              store_token.setlocal('user',data.user)
              commit('auth_success',data)
              Vue.noty.success('Welcome '+ data.user );
              resolve(resp)
            }
            else{
              commit('auth_error')
              store_token.deletelocalToken('auth_token')
              store_token.deletelocalToken('refresh_token')
              Vue.noty.error('Incorrect password or user')
              reject(err)
            }
          })
          .catch(err => {
            commit('auth_error')
            Vue.noty.error('Incorrect password or user')
            store_token.deletelocalToken('auth_token')
            store_token.deletelocalToken('refresh_token')
            reject(err)
          })
        })
    },
    /*register({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({url: server_path + 'api/register/', data: user, method: 'POST' })
          .then(resp => {
            const auth_token = resp.data.token
            const user = resp.data.user
            store_token.setlocalToken('auth_token',auth_token)
            commit('auth_success', auth_token, user)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error', err)
            store_token.deletelocalToken('auth_token')
            reject(err)
        })
      })
    },*/
    logout({commit}){
      return new Promise((resolve, reject) => {
        commit('logout')
        store_token.deletelocalToken('auth_token')
        store_token.deletelocalToken('refresh_token')
        Vue.noty.success("Goodbye")
        router.push('/')
        resolve('OK')
      })
    },
    refresh_token({commit}){
      if (this.state.refresh_token){
        return new Promise((resolve, reject) => {
          axios({url: server_path + 'auth-oomur/refresh/', data:{refresh:this.state.refresh_token}, method: 'POST' })
          .then(resp => {
            store_token.setlocalToken('auth_token',resp.data.access)
            commit('auth_validate',resp.data.access)
          })
          .catch(err => {
            store_token.deletelocalToken('auth_token')
            store_token.deletelocalToken('refresh_token')
            commit('logout')
            Vue.router.push('/')
            Vue.noty.error('Expired Sesion')
          })
        })
      }else {
        commit('logout')
      }
    },
    // Map layers actions
    changeMapLayersState(context, layer){
      context.commit('set_layer_visible', layer)
    },
    changeLoaderStatus(context, data) {
      context.commit('set_loader_status', data)
    },
    changeLegendURLStatus(context, data) {
      context.commit('set_legendURL_status', data)
    },
    // Mosaics actions
    changeMosaicsGlobalOrCampaigns(context, globalOrCampaigns){
      context.commit('set_mosaics_global_or_campaigns', globalOrCampaigns)
    },
    changeMosaicsCampaignsList(context, mosaicsCampaignsList){
      context.commit('set_mosaics_campaigns_list', mosaicsCampaignsList)
    },
    changeMosaicsCampaignsListFiltered(context, mosaicsCampaignsListFiltered){
      context.commit('set_mosaics_campaigns_list_filtered', mosaicsCampaignsListFiltered)
    },
    changeMosaicCampaignSelected(context, mosaicCampaignSelected){
      context.commit('set_mosaic_campaign_selected', mosaicCampaignSelected)
    },
    // Sonar actions
    changeSonarsGlobalOrCampaigns(context, globalOrCampaigns){
      context.commit('set_sonars_global_or_campaigns', globalOrCampaigns)
    },
    changeSonarsCampaignsList(context, sonarsCampaignsList){
      context.commit('set_sonars_campaigns_list', sonarsCampaignsList)
    },
    changeSonarsCampaignsListFiltered(context, sonarsCampaignsListFiltered){
      context.commit('set_sonars_campaigns_list_filtered', sonarsCampaignsListFiltered)
    },
    changeSonarCampaignSelected(context, sonarCampaignSelected){
      context.commit('set_sonar_campaign_selected', sonarCampaignSelected)
    },
    // Params actions
    changeParamsStationsOrDensityMaps(context, stationsOrDensity){
      context.commit('set_params_stations_or_density_maps', stationsOrDensity)
    },
    changeParamsCampaignsList(context, paramsCampaignsList){
      context.commit('set_params_campaigns_list', paramsCampaignsList)
    },
    changeParamsCampaignsListFiltered(context, paramsCampaignsListFiltered){
      context.commit('set_params_campaigns_list_filtered', paramsCampaignsListFiltered)
    },
    changeParamsCampaignSelected(context, paramsCampaignSelected){
      context.commit('set_params_campaign_selected', paramsCampaignSelected)
    },
    changeDensitySelectedParam(context, densitySelectedParam){
      context.commit('set_density_selected_param', densitySelectedParam)
    },
    // Bathymetry actions
    changeBathymetryGlobalOrCampaigns(context, globalOrCampaigns){
      context.commit('set_bathymetry_global_or_campaigns', globalOrCampaigns)
    },
    changeBathymetryCampaignsList(context, bathymetryCampaignsList){
      context.commit('set_bathymetry_campaigns_list', bathymetryCampaignsList)
    },
    changeBathymetryCampaignsListFiltered(context, bathymetryCampaignsListFiltered){
      context.commit('set_bathymetry_campaigns_list_filtered', bathymetryCampaignsListFiltered)
    },
    changeBathymetryCampaignSelected(context, bathymetryCampaignSelected){
      context.commit('set_bathymetry_campaign_selected', bathymetryCampaignSelected)
    },
    // Theme action
    changeTheme(context, newTheme){
      context.commit('set_theme', newTheme)
    },
  },
  getters : {
    isLoggedIn: state => !!state.auth_token,
    authStatus: state => state.status,
    token: state => state.auth_token,
    user: state => state.user,
    isLoading: state => state.isLoading,
    legendURL: state => state.legendURL,
    // Map layers
    isLayerMosaicsVisible: state => state.mapLayers.layerMosaics.layerMosaicsVisible,
    isLayerSonarsVisible: state => state.mapLayers.layerSonars.layerSonarsVisible,
    isLayerParamsVisible: state => state.mapLayers.layerParams.layerParamsVisible,
    isLayerBathymetryVisible: state => state.mapLayers.layerBathymetry.layerBathymetryVisible,
    // Mosaics
    isGlobalMosaicVisible: state => state.mapLayers.layerMosaics.mosaicsGlobal,
    areCampaignMosaicsVisible: state => state.mapLayers.layerMosaics.mosaicsCampaigns,
    mosaicsCampaignsList: state => state.mapLayers.layerMosaics.mosaicsCampaignsList,
    mosaicsCampaignsListFiltered: state => state.mapLayers.layerMosaics.mosaicsCampaignsListFiltered,
    mosaicCampaignSelected: state => state.mapLayers.layerMosaics.mosaicCampaignSelected,
    mosaicUid: state => state.mapLayers.layerMosaics.mosaicUid,
    // Sonar
    isGlobalSonarVisible: state => state.mapLayers.layerSonars.sonarsGlobal,
    areCampaignSonarsVisible: state => state.mapLayers.layerSonars.sonarsCampaigns,
    sonarsCampaignsList: state => state.mapLayers.layerSonars.sonarsCampaignsList,
    sonarsCampaignsListFiltered: state => state.mapLayers.layerSonars.sonarsCampaignsListFiltered,
    sonarCampaignSelected: state => state.mapLayers.layerSonars.sonarCampaignSelected,
    sonarUid: state => state.mapLayers.layerSonars.sonarUid,
    // Params
    areStationsVisible: state => state.mapLayers.layerParams.paramsStations,
    areDensityMapsVisible: state => state.mapLayers.layerParams.paramsDensityMaps,
    paramsCampaignsList: state => state.mapLayers.layerParams.paramsCampaignsList,
    paramsCampaignsListFiltered: state => state.mapLayers.layerParams.paramsCampaignsListFiltered,
    paramsCampaignSelected: state => state.mapLayers.layerParams.paramsCampaignSelected,
    platform_id: state => state.mapLayers.layerParams.platform_id,
    densitySelectedParam: state => state.mapLayers.layerParams.densitySelectedParam,
    // Bathymetry
    isGlobalBathymetryVisible: state => state.mapLayers.layerBathymetry.bathymetryGlobal,
    areCampaignBathymetryVisible: state => state.mapLayers.layerBathymetry.bathymetryCampaigns,
    bathymetryCampaignsList: state => state.mapLayers.layerBathymetry.bathymetryCampaignsList,
    bathymetryCampaignsListFiltered: state => state.mapLayers.layerBathymetry.bathymetryCampaignsListFiltered,
    bathymetryCampaignSelected: state => state.mapLayers.layerBathymetry.bathymetryCampaignSelected,
    bathymetryUid: state => state.mapLayers.layerBathymetry.bathymetryUid,
    // Theme
    theme: state => state.UI.theme
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js